export default "Ballerup Gokart- & Eventcenter åbnede i 2006. De åbnede deres første escape room i juni 2021.";